module.exports = __webpack_public_path__ + "static/img/360.300ed13c.png";